<template>
  <div id="app" class="min-h-screen bg-center bg-cover bg-no-repeat app-background">
    <router-view />
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  name: 'App',
  components: {
    FooterSection
  }
});
</script>
